// extracted by mini-css-extract-plugin
export default {"icon":"AXe47EGp"};